import React from 'react';
import PropTypes from 'prop-types';

const LiveStats = ({ stats, loading }) => {
  if (loading && !stats) {
    return (
      <div className="grid grid-cols-1 gap-3 sm:gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {[...Array(4)].map((_, i) => (
          <div 
            key={i} 
            className="rounded-lg animate-pulse p-4 sm:p-5 bg-bg-elevated/60 border border-primary-500/10"
          >
            <div className="h-4 rounded w-24 mb-3 bg-primary-500/10"></div>
            <div className="h-8 rounded w-16 bg-primary-500/10"></div>
          </div>
        ))}
      </div>
    );
  }

  const cards = [
    {
      name: 'Success Rate',
      value: `${stats?.success_rate?.toFixed(1) || '0.0'}%`
    },
    {
      name: 'Avg Latency',
      value: `${stats?.avg_latency_ms?.toFixed(0) || '0'}ms`
    },
    {
      name: 'Total Tokens',
      value: (stats?.total_tokens || 0).toLocaleString()
    },
    {
      name: 'Total Cost',
      value: `$${stats?.total_cost?.toFixed(2) || '0.00'}`
    }
  ];

  return (
    <div className="grid grid-cols-4 gap-4">
      {cards.map((card) => (
        <div
          key={card.name}
          className="rounded-lg p-4 transition-all duration-200 bg-bg-elevated/60 border border-primary-500/10 hover:border-primary-500/25 hover:shadow-glow-sm"
        >
          <dt className="text-xs mb-1.5 text-text-tertiary">
            {card.name}
          </dt>
          <dd className="text-xl font-semibold text-text-primary">
            {card.value}
          </dd>
        </div>
      ))}
    </div>
  );
};

LiveStats.propTypes = {
  stats: PropTypes.shape({
    success_rate: PropTypes.number,
    avg_latency_ms: PropTypes.number,
    total_tokens: PropTypes.number,
    total_cost: PropTypes.number
  }),
  loading: PropTypes.bool
};

export default LiveStats;
